
import React, { useState, useRef } from 'react';
import { Container } from 'react-bootstrap';

import uploadIcon from './../assets/file-upload.svg'


const FileDropZone = ({setFileHandler}) => {

  const [ overlay, setOverlay ] = useState(false);
  const inputSelector = useRef();

  const dragOverHandler = (e) => {
    setOverlay(true);
    e.preventDefault();
  }

  const dragLeaveHandler = (e) => {
    setOverlay(false);
    e.preventDefault();
  }

  const fileDropHandler = (e) => {
    e.preventDefault();
    setFileHandler(e.dataTransfer.files[0]);
  }

  const openFileSelector = () => {
    inputSelector.current.click();
  };

  const fileSelectorBindFile = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setFileHandler(e.target.files[0]);
  }


  const renderDropZone = () => {
    if( !overlay ) {
      return (
        <div data-testid="file-dropzone" className="file-drop-zone--droparea" onClick={()=>openFileSelector()}>
          <div className="drop-icon">
            <div className="icon">
              <img src={uploadIcon}/>
            </div>
            <div>
              Drag here or
            </div>
            <span className="highlight">Browse</span> to upload
          </div>
        </div>
      )
    } else {
      return (
        <div data-testid="file-dropzone-overlay" className="file-drop-zone--droparea-overlay">
          <div className="drop-icon">
            <div>
              <span className="highlight">Drop</span> The File Here
            </div>
          </div>
        </div>
      )
    }
  }

  return (
    <Container fluid>
      <div className="file-drop-zone"
        onDragOver={dragOverHandler}
        onDragLeave={dragLeaveHandler}
        onDrop={fileDropHandler}
      >
        <input data-testid="file-selector" id="fileSelector" type="file" ref={inputSelector} style={{display: 'none'}} onChange={(e)=>fileSelectorBindFile(e)} accept=""/>
        { renderDropZone() }
      </div>
    </Container>
  )

}


export default FileDropZone;

